import { createSlice } from '@reduxjs/toolkit';
import { GoalTypeState } from './goaltypeTypes';
import { createGoaltype, UpdateGoaltype, fetchAllGoaltype, fetchGoalById, deleteGoaltype } from './goaltypeAction';

const initialState: GoalTypeState = {
    goaltype: [],
    selectedgoaltype: undefined,
    loadingStates: {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}

const goaltypeSlice = createSlice({
    name: 'goaltype',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createGoaltype.pending, (state) => {
                state.loadingStates.create = true;
                state.errors.create = undefined;
            })
            .addCase(createGoaltype.fulfilled, (state, action) => {
                state.loadingStates.create = false;
                state.goaltype.push(action.payload);
            })
            .addCase(createGoaltype.rejected, (state, action) => {
                state.loadingStates.create = false;
                state.errors.create = action.payload as string;
            })

            // Update 
            .addCase(UpdateGoaltype.pending, (state) => {
                state.loadingStates.update = true;
                state.errors.update = undefined;
            })
            .addCase(UpdateGoaltype.fulfilled, (state, action) => {
                state.loadingStates.update = false;
                const index = state.goaltype.findIndex((d: any) => d.Id === action.payload.Id);
                if (index !== -1) {
                    state.goaltype[index] = action.payload;
                }
            })
            .addCase(UpdateGoaltype.rejected, (state, action) => {
                state.loadingStates.update = false;
                state.errors.update = action.payload as string;
            })

            // Delete 
            .addCase(deleteGoaltype.pending, (state) => {
                state.loadingStates.delete = true;
                state.errors.delete = undefined;
            })
            .addCase(deleteGoaltype.fulfilled, (state, action) => {
                state.loadingStates.delete = false;
                state.goaltype = state.goaltype.filter((d: any) => d.Id !== action.payload);
            })
            .addCase(deleteGoaltype.rejected, (state, action) => {
                state.loadingStates.delete = false;
                state.errors.delete = action.payload as string;
            })

            // Fetch  by ID
            .addCase(fetchGoalById.pending, (state) => {
                state.loadingStates.fetchById = true;
                state.errors.fetchById = undefined;
            })
            .addCase(fetchGoalById.fulfilled, (state, action) => {
                state.loadingStates.fetchById = false;
                state.selectedgoaltype = action.payload;
            })
            .addCase(fetchGoalById.rejected, (state, action) => {
                state.loadingStates.fetchById = false;
                state.errors.fetchById = action.payload as string;
            })

            // Fetch All 
            .addCase(fetchAllGoaltype.pending, (state) => {
                state.loadingStates.fetchAll = true;
                state.errors.fetchAll = undefined;
            })
            .addCase(fetchAllGoaltype.fulfilled, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.goaltype = action.payload.data;
            })
            .addCase(fetchAllGoaltype.rejected, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.errors.fetchAll = action.payload as string;
            });
    }
})


export default goaltypeSlice.reducer;